import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Institution
 */
@Entity()
export class Institution extends Partner {
  static override _class = 'Institution';

  override get type() {
    return KooperationsPartner.INSTITUTION;
  }
}
